/**
 * Created by Josef Jurca on 8.3.2017.
 */

import {ActionTypes, LinearChannelStatuses} from '../actions/linearchannels';

const defaultState = {
    channels: {},
    status: LinearChannelStatuses.REQUEST_OPEN,
    error: ''
};

/**
 * Returns the set linear channels state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
function channels (state = {}, action) {

    switch (action.type) {

        case ActionTypes.SET_LINEAR_CHANNELS:

            // TODO REview this, it nests channels and channels everytime this action is called
            return Object.assign({}, state, action.linearChannels);

        default:
            return state;
    }
}

/**
 * Returns the linear channels status state.
 *
 * @param {string} state - Current state.
 * @param {Object} action - Action object.
 * @returns {string} State.
 */
function status (state = LinearChannelStatuses.REQUEST_OPEN, action) {

    switch (action.type) {

        case ActionTypes.LINEAR_CHANNELS_SET_STATUS:
            return (state = action.status);

        default:
            return state;
    }
}

/**
 * Returns the linear channels error state.
 *
 * @param {string} state - Current state.
 * @param {Object} action - Action object.
 * @returns {string} State.
 */
function error (state = '', action) {

    switch (action.type) {

        case ActionTypes.LINEAR_CHANNELS_SET_ERROR:
            return (state = action.error || '');

        default:
            return state;
    }
}

/**
 * Returns the linear channels state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
export default function linearChannels (state = defaultState, action) {
    return {
        channels: channels(state.channels, action),
        status: status(state.status, action),
        error: error(state.error, action)
    };
}


// WEBPACK FOOTER //
// ./src/js/store/reducers/linearchannels.js